"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
function _export(target, all) {
    for(var name in all)Object.defineProperty(target, name, {
        enumerable: true,
        get: all[name]
    });
}
_export(exports, {
    ThemeContext: function() {
        return ThemeContext;
    },
    ThemeProvider: function() {
        return ThemeProvider;
    }
});
const _interop_require_wildcard = require("@swc/helpers/_/_interop_require_wildcard");
const _react = /*#__PURE__*/ _interop_require_wildcard._(require("react"));
const ThemeContext = /*#__PURE__*/ _react.createContext(undefined);
const ThemeProvider = ThemeContext.Provider;
